export default __webpack_public_path__ + "static/media/warning.d0632c5b.svg";